import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCogs,
  faCheck,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import { DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap";
import { Button, Col, Modal, Row } from "react-bootstrap";
import axios from "axios";
import Moment from "react-moment";
import "moment/locale/es-mx"

export default class ReportePDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      modalFinaliza: false,
      finalizaAmbito: null,
      existe: false,
      nombre_archivo: "",
      fecha: "",
      regenera: false,
      contador: 0,
    };
  }

  componentDidMount() {

  }

  checaRegenera = () => {
    let contador = this.state.contador + 1
    if (contador == 10 && this.state.regenera) {
      this.existeFnc()
      contador = 0
    }
    this.setState({ contador: contador })
  }

  existeFnc = () => {
    this.setState({ contador: 0 })
    axios({
      method: "get",
      url:
        "http://143.198.191.211/pdf/existe/" +
        "?a=" +
        this.props.ambito.id +
        "&t=acta" +
        "&api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      console.log(res.data)
      this.setState({
        regenera: res.data.regenera,
        existe: res.data.existe,
        nombre_archivo: res.data.nombre_archivo,
        fecha: res.data.fecha
      })
    })
  }

  abre_link = (href) => {
    window.open(href, "_blank")
  }

  regeneraBtn = () => {
    this.setState({ regenera: true, existe: false, contador: 0 })
    axios({
      method: "get",
      url:
        "http://143.198.191.211/pdf/acta/" +
        "?c=97sgJjUr" +
        "&a=" +
        this.props.ambito.id +
        "&api_token=" +
        localStorage.api_token,
      data: {},
    })
  }

  showModalFinaliza = (ambito) => {
    this.setState({ modalFinaliza: true, finalizaAmbito: ambito });
  };

  hideModalFinaliza = () => {
    this.setState({ modalFinaliza: false });
  };

  doFinaliza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.props.ambito.id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put(
        "http://143.198.191.211/api/Ambito/Finaliza/" + this.props.ambito.id,
        data,
        config
      )
      .then((res) => {
        this.props.cargaTabla();
        this.props.cargaDescendientes();
        this.setState({ modalFinaliza: false, regenera: true });
      });
  };

  render() {
    return (
      <>
        {
          localStorage.ambitos.includes(this.props.ambito.id) ?
            this.props.ambito.fecha_finalizado == null ?
              <Button
                className="btn-finaliza-ambito btn-danger"
                data-tip={"Finalizar Ambito " + this.props.ambito.id}
                onClick={() => this.showModalFinaliza(this.props.ambito)}>
                <FontAwesomeIcon icon={faCheck} size="lg" />
                &nbsp;
                Finalizar
              </Button>
              :
              <DropdownButton as={ButtonGroup}
                style={this.props.style}
                onClick={() => this.existeFnc()}
                title={<span><FontAwesomeIcon
                  icon={faFilePdf} /> Descargar PDF</span>}>
                {this.state.existe &&
                  <>
                    <Dropdown.Item
                      eventKey="1"
                      onClick={() => this.abre_link("http://143.198.191.211/pdf/acta/?a=" + this.props.ambito.id)}
                      data-tip={"Descarga Acta PDF " + this.props.ambito.id}
                      style={{
                        textAlign: "center"
                      }}>
                      <FontAwesomeIcon icon={faFilePdf} /> Descargar Acta PDF
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="2"
                      onClick={() => this.abre_link("http://143.198.191.211/pdf/dirgral/workpdfs/Ambito-" + this.props.ambito.id + ".pdf")}
                      data-tip={"Descarga reporte concentrado de todos los anexos asignados al ámbito " + this.props.ambito_id + " (Generado el " + this.state.fecha + ")"}
                      style={{
                        textAlign: "center"
                      }}>
                      <FontAwesomeIcon icon={faFilePdf} /> Descargar Concentrado PDF
                      <br></br>
                      (Generado {" "}
                      <Moment interval={30000} calendar locale="es-mx">
                        {this.state.fecha}
                      </Moment>
                      )
                    </Dropdown.Item>
                  </>
                }
                {
                  this.state.regenera &&
                  <Dropdown.Item
                    disabled={true}
                    eventKey="3"
                    data-tip={"Finalizando; dependiendo de la cantidad de registros esto puede tomar un tiempo."}
                    style={{
                      textAlign: "center"
                    }}>
                    <FontAwesomeIcon icon={faCogs} /> Finalizando Ambito {this.props.ambito.id}...
                  </Dropdown.Item>
                }
              </DropdownButton >
            :
            <span className="text-muted">Ambito Descendiente</span>
        }

        <Modal
          onHide={() => this.hideModalFinaliza()}
          show={this.state.modalFinaliza}
          size="lg"
          centered
        >
          <Modal.Header>
            <Modal.Title>Finalizar Ámbito {this.state.finalizaAmbito && this.state.finalizaAmbito.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12" md="12" lg="12">
                {this.state.finalizaAmbito &&
                  <h3>¿Esta seguro que desea finalizar el ámbito {this.state.finalizaAmbito.id}?</h3>
                }
              </Col>
              <br></br>
              &nbsp;
              <br></br>
              <Col xs="12" md="12" lg="12">
                {this.state.finalizaAmbito &&
                  <h5>
                    El ámbito {this.state.finalizaAmbito.id} corresponde a <b>{" "}
                      {this.state.finalizaAmbito.dirgral}
                      {this.state.finalizaAmbito.dir ? " / " + this.state.finalizaAmbito.dir : null}
                      {this.state.finalizaAmbito.depto ? " / " + this.state.finalizaAmbito.depto : null}</b>
                  </h5>
                }
              </Col>
              <br></br>
              &nbsp;
              <br></br>
              <Col xs="12" md="12" lg="12">
                <h5><b>Esta acción no se puede deshacer.</b></h5>
                <br></br>
                <h5><b>Dependiendo del número de anexos y registros esto puede tomar varios minutos.</b></h5>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.hideModalFinaliza()}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={() => this.doFinaliza()}>
              <FontAwesomeIcon icon={faCheck} size="lg" />
              &nbsp;
              Finalizar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
